<template>
    <div id="discussions-app" class="vx-row">
      <view-image v-if="viewActive" :src="viewImageSrc"></view-image>

      <div class="ch-container vx-col w-full">
        <h4 class="mb-4">{{$route.query.privacy === 'my-students' ? ' النقاشات الخاصة بمجموعاتي' : 'نقاشات لكل مجموعات المادة'}}</h4>
        <post-form :privacy="privacy" @submit="savePost" @viewImage="viewImage"></post-form>

        <vs-button @click="addNewPosts" v-if="newPosts.length > 0" class="mt-base w-full" type="border">يوجد {{newPosts.length}} منشورات</vs-button>

        <post v-for="(post, index) in sortedCoursePosts"
              class="mt-base" :key="post.id" :post="post"
              @deleted="$delete(posts, index)"
              @viewImage="viewImage" />

        <infinite-loading :key="privacy" spinner="spiral" @infinite="loadPosts" ref="InfiniteLoading">
          <div slot="no-more" class="mt-base bg-white p-5 rounded-lg shadow">
            <template v-if="posts.length > 0">
              لا يوجد المزيد من النقاشات
            </template>
            <template v-else>
              <img class="w-full mb-base max-w-xs" src="@/assets/images/svg/no-data.svg" alt="quizzes.svg">
              <h5 class="text-left">
                <span>لم يتم العثور علي نقاشات، كن أول من ينشأ نقاش.</span>
              </h5>
            </template>
          </div>
          <div slot="no-results" class="mt-8 text-center"></div>
        </infinite-loading>
      </div>
    </div>
</template>

<script>
    import moment from 'moment'
    moment.locale('ar-ly')

    import viewImage from '@/views/components/ViewImage'
    import postForm from './PostForm'
    import postsAPI from "@/api/postsAPI"
    import Post from "@/views/course/discussions/Post";
    import InfiniteLoading from 'vue-infinite-loading';

    export default {
        name: "Discussions",
        components: {
            viewImage,
            postForm,
            Post,
            InfiniteLoading
        },
        data() {
            return {
                course_id: this.$route.params.course_id,
                viewImageSrc: null,
                viewActive: false,
                postsPerPage: 10,
                page: 1,
                posts: [],
                newPosts: [],
                listenerRegistered: null,
                term: null,
                privacy: this.$route.query.privacy === 'my-students' ? 'private' : 'public'
            }
        },
        watch: {
            '$route.query' (val) {
                this.posts = []
                this.page = 1
                this.newPosts = []

                this.privacy = val.privacy === 'my-students' ? 'private' : 'public'
                // this.$refs.InfiniteLoading.stateChanger.reset()
            }
        },
        computed: {
            sortedCoursePosts() {
                return this.posts.slice().sort( ( a, b) => {
                    return new Date(b.updated_at) - new Date(a.updated_at);
                });
            },
        },
        methods: {
            addNewPosts(){
                this.newPosts.forEach(post => this.posts.unshift(post))

                this.newPosts = []
            },
            savePost(post){
              this.posts.unshift(post)
            },
            loadPosts($state) {
                postsAPI.getByPageAll(this.page, this.postsPerPage, this.privacy)
                   .then(({data}) => {
                       this.term = data.active_term

                       if(!this.listenerRegistered) this.registerListener(this.term)

                       if (data.posts.length > 0) {
                           data.posts.forEach(post => this.posts.push(post))
                           this.page += 1;
                           $state.loaded();
                       } else {
                           $state.complete();
                       }
                   })
            },
            viewImage(src) {
               this.viewActive = true
               this.viewImageSrc = src
            },
            registerListener(term) {
              let self = this
              let channel = window.Echo.channel('course.' + this.$route.params.course_id + '.' + term)
              channel.listen('.posts', function(data) {
                self.handleObserverPosts(data.post)
              });
            },
            unregisterListener(term) {
                window.Echo.leave('course.' + this.$route.params.course_id + '.' + term)
            },
            handleObserverPosts(newPost){
                if(newPost.privacy !== this.privacy) return
                let post = this.posts.find(post => {return newPost.id === post.id})
                if(post){
                    newPost.comments.forEach(newPostComment => {
                        let comment = post.comments.find(comment => {return comment.id === newPostComment.id})
                        if(!comment){
                            post.comments.push(newPostComment)
                        }
                    })
                } else {
                    this.newPosts.unshift(newPost)
                }
            },
        },
        created() {
            if(!this.$store.state.courses.all[this.$route.params.course_id]) {
                this.$router.push('/not-found-404')
            }
        },
        beforeRouteLeave(to, from, next){
            this.unregisterListener(this.term)
            next()
        },
    }
</script>
